var GRID_FIT_ALIGN = {
    MIDDLE: 'MIDDLE',
    TOP: 'TOP',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    BOTTOM: 'BOTTOM',
};
export default GRID_FIT_ALIGN;
//# sourceMappingURL=cubeFitPosition.js.map